import React from "react";
import Routes from "../Routes";

const Layout = () => <Routes />;

export default Layout;
